import { IAutoMapper } from "../interfaces";

export const mapMemberM360Item = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "MemberItem")
    .forMember("memRecordId", o => o.memRecordId)
    .forMember("tenantId", o => o.tenantId)
    .forMember("memberId", o => o.memberId)
    .forMember("m360MemberId", o => o.m360MemberId)
    .forMember("firstName", o => o.firstName)
    .forMember("lastName", o => o.lastName)
    .forMember("dob", o => o.dob)
    .forMember("gender", o => o.gender)
    .forMember("potentialDuplicateRecords", o => o.potentialDuplicateRecords)
    .forMember("conflictRecords", o => o.conflictRecords)
    .forMember("conflictFlag", o => o.conflictFlag);
};
